import React from "react";
import "./index.css";
import InfoIcon from "../InfoIcon";
import SystemBoundary from "./SystemBoundary";

const GraphicIcon = ({ icon }) => (
  <img src={icon} width={18} height={18} alt="Graphic Icon" />
);

const LeftBox = ({
  icon,
  title,
  description,
  show,
  graphicIcons,
  showInfoIcon,
  infoText,
  isSystemBoundary,
  systemBoundary,
  setSystemBoundary,
  productId,
  createSystemBoundaryFunc,
  isManufacturing,
  isCategory,
  handleShowCategory,
  showCategory,
  customTextColor,
}) => {
  return (
    <div className="left-box">
      <div className="left-icon">{icon}</div>
      <div className="left-box-body">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingLeft: "3px",
          }}
        >
          <div style={{ display: "flex", position: "relative" }}>
            <h2 style={{ fontWeight: "bold", color: customTextColor || "white" }}>{title}</h2>
            {showInfoIcon && <InfoIcon text={infoText} />}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            {graphicIcons && (
              <div className="graphic-icons">
                {graphicIcons?.map((icon, index) => (
                  <GraphicIcon key={index} {...icon} />
                ))}
              </div>
            )}
          </div>
        </div>
        <p
          style={{
            textOverflow: show ? "initial" : "ellipsis",
            overflow: "hidden",
            maxWidth: "100%",
          }}
        >
          {description}
        </p>
        {isCategory && (
          <div className="create-category-bg" style={{ maxWidth: "70%" }}>
            <div className="create-category-left">
              <h5 style={{ color: "#203669", fontSize: "14px" }}>
                Create Category
              </h5>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <h5
                style={{
                  color: "white",
                  marginRight: "5px",
                  fontSize: "14px",
                }}
              >
                Add
              </h5>
              <div
                className="create-category-switch"
                onClick={handleShowCategory}
                style={{
                  maxWidth: "fit-content",
                  display: "flex",
                  height: "100%",
                }}
              >
                <div
                  className={
                    showCategory ? "create-category-chosen-switch" : ""
                  }
                  style={{ width: "50px", height: "100%" }}
                ></div>
                <div
                  className={
                    !showCategory ? "create-category-chosen-switch" : ""
                  }
                  style={{ width: "50px", height: "100%" }}
                ></div>
              </div>
              <h5
                style={{ color: "white", marginLeft: "5px", fontSize: "14px" }}
              >
                Off
              </h5>
            </div>
          </div>
        )}
        {isSystemBoundary && (
          <div style={{ marginLeft: "20px" }}>
            <SystemBoundary
              systemBoundary={systemBoundary}
              setSystemBoundary={setSystemBoundary}
              productId={productId}
              createSystemBoundaryFunc={createSystemBoundaryFunc}
              isManufacturing={isManufacturing}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default LeftBox;
